import React, { useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import Button from "sushiweb/Button";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import useForm from "../Common/FormComponent/useForm";
import FormComponent from "../Common/FormComponent/FormComponent";
import {
  createNewElementForm,
  elementType,
  pathMappingsReverse,
} from "./constants";

const CreateNewElementDialog = ({ options, tag }) => {
  const [open, setOpen] = useState(false);
  const form = useForm({
    elementType: elementType[0].value,
  });
  const history = useHistory();
  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="sushi-btn"
        data-testid="hubAddNewBtn"
      >
        Create element
      </Button>
      {open && (
        <NoFooterModal
          handleClose={() => setOpen(false)}
          header
          heading="Select element type"
        >
          <Box display={"flex"} gap={1} alignItems={"center"}>
            {createNewElementForm.map((item) => (
              <FormComponent
                config={item}
                form={form}
                key={item.id}
                otherOptions={options?.element_types}
              />
            ))}
          </Box>
          <Box mt={4} display={"flex"} justifyContent={"end"}>
            <Button
              onClick={() =>
                history.push(
                  `/communication-hub/new/${
                    pathMappingsReverse[form.values["elementType"]]
                  }`
                )
              }
              className="sushi-btn"
            >
              Confirm
            </Button>
          </Box>
        </NoFooterModal>
      )}
    </>
  );
};

export default CreateNewElementDialog;
